import React from 'react'
import BaseStep from '../BaseStep'
import CardSelectable from '../commons/CardSelectable'
import Back from '../commons/Back'
import GenericIcon from 'components/GenericIcon'

class LoadPropertyType extends BaseStep {

  onClick = (answer) => {
    this.props.onChoice({ loanPropertyType: answer })
  }

  question = () => {
    return I18n.t(`onboarding.loan_property_type.${this.props.loanPurpose}.question`)
  }

  render() {
    return (
      <div ref={ (ref) => this.cardsContainer = ref } >
        <h3 className="onboarding-title text-center">
          { this.question() }
        </h3>
        <div className="row">
          <div className="col-sm-3">
            <CardSelectable
              onClick={ () => this.onClick('house') }
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
            >
              <GenericIcon name='homeGarage' />
              <h4>{ I18n.t(`onboarding.loan_property_type.answer.house`) }</h4>
            </CardSelectable>
          </div>
          <div className="col-sm-3">
            <CardSelectable
              onClick={ () => this.onClick('apartment') }
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
            >
              <GenericIcon name='apartment' />
              <h4>{ I18n.t(`onboarding.loan_property_type.answer.apartment`) }</h4>
            </CardSelectable>
          </div>
          <div className="col-sm-3">
            <CardSelectable
              onClick={ () => this.onClick('commercial') }
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
            >
              <GenericIcon name='commercial' />
              <h4>{ I18n.t(`onboarding.loan_property_type.answer.commercial`) }</h4>
            </CardSelectable>
          </div>
          <div className="col-sm-3">
            <CardSelectable
              onClick={ () => this.onClick('vacant') }
              onMouseEnter={(e) => this.onMouseEnter(e) }
              onMouseLeave={() => this.onMouseLeave() }
            >
              <GenericIcon name='vacantLand' />
              <h4>{ I18n.t(`onboarding.loan_property_type.answer.vacant`) }</h4>
            </CardSelectable>
          </div>
        </div>
        <Back onGoBack={this.props.onGoBack} />
      </div>
    )
  }
}

export default LoadPropertyType;
